import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import { mapTruncateValue } from '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';

function useTextStyles(as, truncate) {
  if (truncate === void 0) {
    truncate = false;
  }

  var props = {
    truncate: mapTruncateValue(truncate)
  };

  switch (as) {
    case 'small':
      props.fontSize = 'text-sm';
      break;

    case 'pre':
    case 'code':
      props.fontFamily = 'font-mono';
      props.fontSize = 'text-code-inline';
      props.fontWeight = 'font-normal';
      break;

    case 'mark':
      props.backgroundColor = 'bg-yellow-100';
      props.textColor = 'text-gray-800';
      props.padding = 'px-1';
      break;
  }

  if (as === 'code') {
    props.textColor = 'text-red-500';
  }

  return props;
}

export default useTextStyles;
//# sourceMappingURL=styles.esm.js.map
